module.exports = __webpack_public_path__ + "static/media/gallery-1.c7f169ef.jpg";